<template>
  <div class="activities">
    <div class="title">
      <div></div>
      兑换列表
    </div>
    <div class="query">
    
      <div class="query-box">
        <el-input v-model="query" placeholder="活动名称"></el-input>
      </div>

      <el-button type="primary" @click="inquire">查询</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
            <el-table-column align="center" prop="activityName" label="活动名称">
        </el-table-column>
    
        <el-table-column align="center" prop="createTime" label="兑换时间">
        </el-table-column>
         <el-table-column align="center" prop="nickname" label="兑换人">
        </el-table-column>

        <el-table-column align="center" prop="phone" label="兑换人电话">
        </el-table-column>
             <el-table-column align="center" prop="addVipDay" label="增加会员有效时间天数">
        </el-table-column>

        <el-table-column align="center" prop="activityCode" label="兑换码">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 3, 5, 10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
 
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import {  recordList } from "@/api/api";
import reg from "@/utils/reg.js";
export default {
  data() {
    return {
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      activityId:'',


    
  
    };
  },
  created() {
    this.activityId=this.$route.query.activityId
    this.getList();
  },
  methods: {

    //  获取活动列表
    async getList() {
      let res = await recordList({
        activityId:this.activityId,
        activityName: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,

      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.list.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.list;
      this.total = data.total;
    },

    // 查询
    inquire() {

      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
</style>